/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { get } from 'lodash'
import { connect } from 'react-redux'

import { fetchInstanceConfigurationsIfNeeded } from '../../../../actions/topology/instanceConfigurations'
import { updateDeployment } from '../../../../actions/stackDeployments'
import {
  getInstanceConfigurations,
  getActiveVersionStacks,
  updateStackDeploymentRequest,
} from '../../../../reducers'
import { getConfigForKey, isFeatureActivated } from '../../../../selectors'
import Feature from '../../../../lib/feature'

import EditDeploymentFromTemplate from './EditDeploymentFromTemplate'

import type { ThunkDispatch } from '../../../../types'
import type { StateProps, DispatchProps, ConsumerProps } from './types'

const mapStateToProps = (state, { editorState }: ConsumerProps): StateProps => {
  const { id, regionId } = editorState

  const instanceConfigurations = getInstanceConfigurations(state, regionId)

  return {
    isHeroku: getConfigForKey(state, `APP_FAMILY`) === `heroku`,
    hideExtraFailoverOptions: isFeatureActivated(state, Feature.hideExtraFailoverOptions),
    instanceConfigurations,
    esVersions: getActiveVersionStacks(state, regionId),
    updateStackDeploymentRequest: updateStackDeploymentRequest(state, id),
    inTrial: get(state, [`profile`, `inTrial`], false),
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  fetchInstanceConfigurationsIfNeeded: (regionId: string) =>
    dispatch(fetchInstanceConfigurationsIfNeeded(regionId)),
  updateDeployment: (args) => dispatch(updateDeployment(args)),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(EditDeploymentFromTemplate)
